export default {
  /**
   * Các đơn vị thuộc ngành giáo dục
   */
  EducationUnit: 1,
  /**
   * Các đơn vị thuộc ngành y tế
   */
  MedicalUnit: 2,
  /**
   * Đơn vị QLNN, Đảng đoàn thể
   */
  StateManagementUnitsAndMassOrganization: 3,
  /**
   * Đơn vị khác
   */
  OtherUnit: 4,
};
